import React from 'react';
import classes from './dimensions.module.css';

var DimensionItem = function DimensionItem(_ref) {
  var measure = _ref.measure,
      value = _ref.value,
      _ref$isPdf = _ref.isPdf,
      isPdf = _ref$isPdf === void 0 ? false : _ref$isPdf;
  return React.createElement("div", {
    className: "flex leading-28 text-black"
  }, React.createElement("p", {
    className: "".concat(classes.measure, " ").concat(isPdf ? classes.pdfMeasure : '')
  }, measure), React.createElement("p", {
    className: classes.value
  }, value));
};

export default DimensionItem;